export const CustomChip = ({ text }) => {
    return (
        <div className="inline-block"   >
            <div className="border-2 border-gray-200  px-1 code-like-font lowercase bg-gray-100  rounded-lg inline-block"   >
                {text}
            </div>
        </div>
    );
}
